import sanitizeHtml from 'sanitize-html'

import { guid } from 'core/classes/helpers/GuidHelper'
import settings from 'src/config/settings'

export const downloadQbrPptxReport = async (uid: string, fileName: string) => {
  const url = `${settings.dataServerUrl}/form/1554/attachments/v2/${uid}/PPTXReport`
  const link = document.createElement('a')
  link.href = sanitizeHtml(`${url}?Guid=${guid()}`)
  link.setAttribute('download', fileName)
  link.setAttribute('target', '_blank')

  const element = document.body || document.documentElement

  element.appendChild(link)
  link.click()
  // small crutch to imitate server response to show loader overlay
  await new Promise((resolve) => setTimeout(() => resolve(true), 1500))
  element.removeChild(link)
}
